export default __webpack_public_path__ + "static/media/weight-loss_gym.937cc843.jpg";